<template>
  <div class="page-title" v-if="showPageTitle">
    <back-btn :moduleName="moduleName"></back-btn>
    <p class="text">{{ title }}</p>
  </div>
</template>

<script lang="ts" setup>
import { useBaseStore } from "@store/base";
import { computed } from "vue";
import BackBtn from "@components/common/BackBtn.vue";
const props = defineProps({
  moduleName: {
    default: "",
  },
  title: {
    default: "",
  },
});
const emits = defineEmits(["setShowTitle"]);
const base = useBaseStore();
const showTitle = computed(() => {
  if (["articledetail", "search"].includes(props.moduleName)) {
    return true;
  }

  return (
    base.navList.findIndex((item) => item.MODULE_ENNAME == props.moduleName) ===
    -1
  );
});

const showPageTitle = computed(() => {
  if (showTitle.value) {
    emits("setShowTitle");
    return true;
  }
  return false;
});
</script>

<style scoped lang="scss">
@import "@assets/scss/dimen.scss";
.page-title {
  display: flex;
  align-items: center;
  height: 112px;
  margin-top: -30px;
  .text {
    font-size: $fzTitle;
    color: $titlecolor;
    font-weight: bold;
    margin-left: 90px;
  }
  &.detail-page-title {
    position: fixed;
    z-index: 2;
    width: 100%;
    background-color: $pagecolor;
    margin-top: unset;
    .text {
      margin-left: 112px;
    }
  }
}

@media (orientation: landscape) {
  .page-title {
    margin-top: -40px;
    &.detail-page-title {
      width: calc(100% - 170px);
      margin-left: 170px;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .page-title {
    height: calc(112px / $pcRate);
    margin-top: calc(-40px / $pcRate);

    .text {
      font-size: $fzTitlePc;
      margin-left: calc(90px / $pcRate);
    }
  }
}
</style>
